import React, {
  AllHTMLAttributes, ComponentClass, FunctionComponent, HTMLAttributes, ReactNode,
} from 'react';
import { Spinner } from 'react-bootstrap';

import './Loading.scss';

interface LoadingAttributes {
  children?: ReactNode;
  className?: string;
  as?: string | FunctionComponent<{}> | ComponentClass<{}, any>;
  isLoading?: boolean;
  onAnimationComplete?: Function;
  delay?: number;
  inline?: boolean;
  largeText?: boolean;
  graphic?: boolean;
  graphicOnly?: boolean;
}

type LoadingProps = LoadingAttributes & AllHTMLAttributes<any>;

export const Loading = ( loadingProps: LoadingProps ) => {
  const attributes = { ...loadingProps }; // These will become HTML attributes
  const {
    as, children, className, inline, isLoading = false, largeText, graphic, graphicOnly,
  } = loadingProps;
  const delay = loadingProps.delay || 1500;

  let LoadingContainer: FunctionComponent<LoadingProps> | typeof Spinner;

  // Delete non-HTML or redundant attributes
  delete attributes.as;
  delete attributes.onAnimationComplete;
  delete attributes.className;
  delete attributes.largeText;
  delete attributes.isLoading;
  delete attributes.graphic;
  delete attributes.graphicOnly;

  if ( as ) {
    LoadingContainer = function _LoadingContainer( props: HTMLAttributes<HTMLDivElement> ) {
      return React.createElement( as, props );
    };
  } else {
    LoadingContainer = function _LoadingContainer( props: HTMLAttributes<HTMLDivElement> ) {
      return React.createElement( 'div', props );
    };
  }

  if ( loadingProps.onAnimationComplete && !isLoading ) {
    setTimeout( () => {
      // @ts-ignore - Not narrowing correctly
      loadingProps.onAnimationComplete();
    }, delay );
  }

  LoadingContainer.displayName = 'LoadingContainer';

  return (
    <LoadingContainer
      data-testid="ops-loading"
      className={ `ops-loading${inline ? ' ops-loading--inline' : ''}${className ? ` ${className}` : ''}` }
      { ...attributes }
    >
      { ( graphic || graphicOnly ) && <Spinner animation="border" /> }
      { !graphicOnly && ' ' }
      { children ? (
        <div className={ `${largeText ? 'h1 ' : ''}ops-loading__text${graphicOnly ? ' sr-only' : ''}` }>{ children }</div>
      ) : (
        <p className={ `${largeText ? 'h1 ' : ''}ops-loading__text${graphicOnly ? ' sr-only' : ''}` }>Loading…</p>
      ) }
    </LoadingContainer>
  );
};

Loading.displayName = 'Loading';
